import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from './auth/auth.service';
import { LuxonLanguageCodes, Translations } from './translations';
import { TranslationsEnum } from 'src/_api/models/translations-enum';
import { EnumService } from './services/enum.service';
import { DateAdapter } from '@angular/material/core';
import { Settings } from 'luxon';
import { take } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TranslateConfigService {
  private readonly LANGUAGE_KEY = 'language';
  private translations = [];

  constructor(
    private translateService: TranslateService,
    private authService: AuthService,
    public enumService: EnumService,
    private dateAdapter: DateAdapter<any>
  ) {
    const savedLanguage = localStorage.getItem(this.LANGUAGE_KEY);
    const defaultLanguage = savedLanguage || Translations[TranslationsEnum.English];
    this.translateService.use(defaultLanguage);
    this.translations = enumService.translations;
  }

  get currentLanguage() {
    return this.translateService.currentLang;
  }

  changeLanguage(type: string) {
    const findTranslation = this.translations.find(t => t.name === type);
    this.authService
      .updateUserLanguage(findTranslation.id)
      .pipe(take(1))
      .subscribe(() => this.setLanguage(type));
  }

  instant(key: string, text?: any) {
    if (key === undefined) {
      key = ' ';
    }
    return this.translateService?.instant(key, { text: text });
  }
  instantWithParams(key: string, interpolateParams?: Object) {
    if (key === undefined) {
      key = ' ';
    }
    return this.translateService?.instant(key, interpolateParams);
  }
  setLanguage(type: string) {
    this.translateService.use(type);
    localStorage.setItem(this.LANGUAGE_KEY, type);

    // Bug 2575. The bug is only half fixed.
    // Commented out for now.
    // The date adapter is not updating the locale on lang switch.
    // Initialization in app.module.ts is working fine.

    // const lang = LuxonLanguageCodes[type];
    // this.dateAdapter.setLocale(lang);
    // Settings.defaultLocale = lang;
  }
}
